/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type BulkReassignSubmissionsParams = {
  from_lecturer_id: string;
  to_lecturer_id: string;
  to_lecturer_title: string;
  state?: string | null;
};
